import { render, staticRenderFns } from "./AfterSaleFillInfo.vue?vue&type=template&id=0706063d&scoped=true&"
import script from "./AfterSaleFillInfo.vue?vue&type=script&lang=js&"
export * from "./AfterSaleFillInfo.vue?vue&type=script&lang=js&"
import style0 from "./AfterSaleFillInfo.vue?vue&type=style&index=0&lang=less&"
import style1 from "./AfterSaleFillInfo.vue?vue&type=style&index=1&id=0706063d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0706063d",
  null
  
)

export default component.exports